import React from 'react';
function SpeechLanguagePathologyPageHeader() {
  return (
    <section className="page-header">
      <div 
        className="page-header-bg" 
        style={{ backgroundImage: "url(assets/images/backgrounds/header1894434.jpg)" }}
      >
      </div>
      <div className="container">
        <div className="page-header__inner">
          <h2>Speech Language Pathology</h2>
          <ul className="thm-breadcrumb list-unstyled">
                        <li><a href="/">Home</a></li>
                        <li><span>/</span></li>
                        <li><a href="">Departments</a></li>
                        <li><span>/</span></li>
                        <li>Speech Language Pathology</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default SpeechLanguagePathologyPageHeader;